import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import {
  AppBar,
  Tab,
  Tabs,
  Typography,
  Paper,
  Container,
  Box,
  Chip,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import {
  Add,
  List,
  Warning,
  AssignmentReturn,
  Assessment,
  Business
} from '@material-ui/icons';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import BonClientService from '../../services/BonClientService';
import ListCommandes from './ListCommandes';
import ListNumeros from './ListNumeros';
import ProduitDefectueux from '../ProduitDefectueux';
import RetourCommande from '../RetourCommande';
import BilanCommande from '../../components/BilanCommande';
import AjoutCommandes from './AjoutCommandes';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    paddingTop: theme.spacing(1),
  },
  appBar: {
    background: 'linear-gradient(135deg, #226D68 0%, #1a524e 100%)',
    borderRadius: '12px 12px 0 0',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%',
  },
  tabs: {
    '& .MuiTab-root': {
      minWidth: 120,
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'none',
      color: theme.palette.common.white,
      opacity: 0.8,
      '&.Mui-selected': {
        opacity: 1,
        color: theme.palette.common.white,
      },
      '&:hover': {
        opacity: 1,
        backgroundColor: 'rgba(242, 101, 34, 0.1)',
      },
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#f26522',
      height: 3,
      borderRadius: 2,
    },
  },
  tabContainer: {
    padding: theme.spacing(4),
    backgroundColor: 'white',
    borderRadius: '0 0 16px 16px',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.08)',
    minHeight: '600px',
    border: `1px solid #e0e0e0`,
    borderTop: 'none',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%',
  },
  // NOUVEAU STYLE POUR LE TITRE COMME DANS L'EXEMPLE
  title: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(2), 
    marginTop: theme.spacing(1), 
    fontSize: '2rem', 
  },
  subtitle: {
    color: 'rgba(255, 255, 255, 0.9)',
    textAlign: 'center',
    fontSize: '1.1rem',
    marginBottom: theme.spacing(3),
  },
  statsContainer: {
    marginTop: theme.spacing(3),
  },
  statCard: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '16px',
    padding: theme.spacing(3),
    textAlign: 'center',
    transition: 'all 0.3s ease',
    border: `1px solid ${theme.palette.divider}`,
    position: 'relative',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 40px rgba(34, 109, 104, 0.15)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #226D68 0%, #f26522 100%)',
    },
  },
  statIcon: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
    background: 'linear-gradient(135deg, #226D68 0%, #2a857e 100%)',
    color: 'white',
    fontSize: 28,
  },
  statNumber: {
    fontWeight: 700,
    color: '#226D68',
    fontSize: '2rem',
    marginBottom: theme.spacing(1),
  },
  statLabel: {
    color: '#666',
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    letterSpacing: '1px',
  },
  featureTag: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: '#f26522',
    color: 'white',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: 600,
  },
  statusChip: {
    borderRadius: '20px',
    fontWeight: 600,
    margin: theme.spacing(0.5),
    fontSize: '0.75rem',
  },
  header: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a857e 100%)',
    color: 'white',
    borderRadius: '20px',
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4),
    boxShadow: '0 8px 32px rgba(34, 109, 104, 0.2)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -50,
      right: -50,
      width: '150px',
      height: '150px',
      background: 'linear-gradient(135deg, rgba(242, 101, 34, 0.15) 0%, transparent 70%)',
      borderRadius: '50%',
    },
  },
  // Nouvelle classe pour le conteneur principal
  pageContainer: {
    minHeight: '100vh',
    paddingTop: theme.spacing(1), 
  },
}));

const StyledTabs = withStyles({
  indicator: {
    backgroundColor: '#f26522',
    height: 3,
    borderRadius: 2,
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    marginRight: theme.spacing(1),
    color: 'rgba(255, 255, 255, 0.7)',
    '&$selected': {
      color: '#fff',
    },
    '&:focus': {
      opacity: 1,
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const TabContainer = ({ children, value, index, hasFeatureTag, featureText, ...other }) => {
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={classes.tabContainer}
      {...other}
    >
      {hasFeatureTag && (
        <Box className={classes.featureTag}>
          {featureText}
        </Box>
      )}
      {value === index && children}
    </div>
  );
};

const Commandes = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const auth = useSelector((state) => state.auth);
  
  const [stats, setStats] = useState({
    pending: [],
    commandesFournisseurs: 0,
    commandesEnCours: 0,
    produitsDefectueux: 0
  });
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(0);

  // Récupération des feature flags
  const featureFlags = {
    bilanCommandes: process.env.REACT_APP_FEATURE_FLIPPING_BILAN_COMMANDES === "true",
  };

  useEffect(() => {
    refreshStats();
  }, []);

  const refreshStats = async () => {
    setLoading(true);
    try {
      const pendingResponse = await BonClientService.getBonClientPending(auth.nom);
      
      // Simuler des données de statistiques (à adapter avec vos vraies données)
      setStats({
        pending: pendingResponse.data,
        commandesFournisseurs: 156,
        commandesEnCours: 23,
        produitsDefectueux: 8
      });
    } catch (error) {
      console.error("Erreur lors du chargement des statistiques:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Configuration des tabs avec icônes et feature tags
  const tabsConfig = [
    { 
      label: "Commandes Fournisseurs", 
      icon: <Business />, 
      visible: true, 
      component: <ListCommandes />,
      featureTag: false
    },
    { 
      label: "Ajouter Commandes", 
      icon: <Add />, 
      visible: true, 
      component: <AjoutCommandes />,
      featureTag: false
    },
    { 
      label: "Liste Numero", 
      icon: <List />, 
      visible: true, 
      component: <ListNumeros />,
      featureTag: false
    },
    { 
      label: "Produits Avariés", 
      icon: <Warning />, 
      visible: true, 
      component: <ProduitDefectueux />,
      featureTag: false
    },
    { 
      label: "Retour Commande", 
      icon: <AssignmentReturn />, 
      visible: true, 
      component: <RetourCommande />,
      featureTag: false
    },
    { 
      label: "Bilan Général", 
      icon: <Assessment />, 
      visible: auth.rol === 'admin' && featureFlags.bilanCommandes, 
      component: <BilanCommande />,
      featureTag: true,
      featureText: "Admin"
    }
  ];

  const visibleTabs = tabsConfig.filter(tab => tab.visible);

  return (
    <div className={classes.pageContainer}>
      <Container maxWidth="xl">
        {/* Titre centré exactement comme dans l'exemple */}
        <Typography variant="h3" className={classes.title}>
          Gestion des Commandes
        </Typography>
        {/* Navigation par onglets */}
        <Paper elevation={0}>
          <AppBar position="static" className={classes.appBar}>
            <StyledTabs 
              value={value} 
              onChange={handleChange}
              className={classes.tabs}
              variant={isMobile ? "scrollable" : "standard"}
              scrollButtons="auto"
              centered
            >
              {visibleTabs.map((tab, index) => (
                <StyledTab
                  key={index}
                  icon={tab.icon}
                  label={isMobile ? null : tab.label}
                  aria-label={tab.label}
                />
              ))}
            </StyledTabs>
          </AppBar>

          {/* Contenu des onglets */}
          {visibleTabs.map((tab, index) => (
            <TabContainer 
              key={index} 
              value={value} 
              index={index}
              hasFeatureTag={tab.featureTag}
              featureText={tab.featureText}
            >
              {tab.component}
            </TabContainer>
          ))}
        </Paper>

       
      </Container>
    </div>
  );
};

export default Commandes;